import { Injectable } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { Observable, Subscription, Subject } from 'rxjs';
import { ClientLocation, ClientVendorCreds, ClientLocationDropDownValue } from '../../clients-module/models/clientLocation';
import { SimpleDataFilter } from '../../models/simpleDataFilter';
import { environment } from 'src/environments/environment';
import { PropertyFilter } from '../models/propertyFilter';
import { ObjectUpdatePayload } from 'src/app/models/screeningInvite';
import {PaginationService} from '../../shared-components-module/pagination-top/services/pagination.service';
import { Address } from 'src/app/models/Address';
import { MarketSegment } from '../models/marketSegment';
import { ProductBillingRule, BillingRuleAssignment } from 'src/app/models/productBilling';

@Injectable({
  providedIn: 'root'
})
export class PropertyService {
  public loading : boolean = false;
  properties : Array<ClientLocation>=[];
  activeClientLocation : ClientLocation;
  public propertyFilter = new PropertyFilter();
  propertiesLoaded : Subject<boolean> = new Subject<boolean>();
  totalPropertyCount : number;
  public marketSegments: MarketSegment[] = [];

  public get activeProperties() : ClientLocation[] {
    return this.properties.filter(pp => { return pp.isActive;});

  }

  /** Normalize API response so id is set when backend sends PascalCase Id (RIQ-5094). */
  private normalizeClientLocation(p: any): ClientLocation {
    const loc = Object.assign(new ClientLocation(), p);
    if (loc.id == null && p?.Id != null) {
      loc.id = p.Id;
    }
    return loc;
  }

  constructor(private http : HttpClient, public toast: ToastrService, private auth : AuthService, private readonly paginationService: PaginationService) 
  {
  }

  FetchPropertyList(filters : PropertyFilter) {
    var offset = (this.paginationService.currentPage -1) * this.paginationService.pageIncrement;

    this.loading = true;
    this.http.post<Array<ClientLocation>>(environment.baseURl + `/api/clientLocation/list/${offset}/${this.paginationService.pageIncrement}`, filters).subscribe((rslt : any) =>{
      this.properties = rslt.listResult.map(p => this.normalizeClientLocation(p));
      this.totalPropertyCount = rslt.totalRecordsCount;
      this.loading = false;
    })
  }

  //SCRSTP-1665: need a method to new up and copy addresses -- object.assign / clone misses the isValid getter which messes
  //up validation.
  copyAddresses(addys: Address[]) : Address[] {
    let returnAddresses: Address[] = [];
    addys.forEach(add => {
      let newAddress = new Address();
      newAddress.street = add.street;
      newAddress.street2 = add.street2;
      newAddress.city = add.city;
      newAddress.region = add.region;
      newAddress.postalCode = add.postalCode;
      newAddress.physical = add.physical;
      newAddress.billing = add.billing;
      //ZERO OUT THE addressIDs or editing the prop address will also edit the client level address!!
      newAddress.id = 0;
      returnAddresses.push(newAddress);
    });
    return returnAddresses;
  }

  FetchAllPropertiesDropDownDataForUser(){
    return this.http.get<ClientLocationDropDownValue[]>(environment.baseURl+'/api/clientlocation/locations');
  }

  FetchMarketSegments(): void {
    this.http.get<MarketSegment[]>(environment.baseURl + '/api/clientLocation/segments').subscribe((res: MarketSegment[]) => {
      if(res) {
        this.marketSegments = res;
      }
    },
    err => { this.toast.error('Error fetching market segments!', '', { closeButton: true, disableTimeOut: true }) },
    () => { });
  }

  FetchPropertiesForClient(clientId : number) {
    this.loading = true;
    this.properties = [];
    this.http.get<Array<ClientLocation>>(environment.baseURl + `/api/clientLocation/locations/${clientId}`).subscribe((rslt : any) =>{
      this.properties = rslt.map(p => this.normalizeClientLocation(p));
      this.propertiesLoaded.next(true);
      this.totalPropertyCount = rslt.totalRecordsCount
      this.loading = false;
    })
  }

  FetchProperty(locationId : number) {
    return this.http.get<ClientLocation>(environment.baseURl + `/api/clientlocation/${locationId}`);
  }

  SaveProperty(loc: ClientLocation): Observable<Object>{
    return this.http.post(environment.baseURl + '/api/clientlocation/locations/save', loc);
  }

  AddVendorCreds(pkg: ClientVendorCreds){
    return this.http.post<number>(environment.baseURl + '/api/clientlocation/loc/creds', pkg);
  }


  GetBillingRules(){
    return this.http.get<ProductBillingRule[]>(environment.baseURl + `/api/clientlocation/billing/rules`);
  }

  GetBillingRulesForLocation(id : number){
    return this.http.get<ProductBillingRule[]>(environment.baseURl + `/api/clientlocation/billing/rules/${id}`);
  }

  SaveBillingRule(rule : BillingRuleAssignment): Observable<Object>{
    return this.http.post(environment.baseURl + `/api/clientlocation/billing/rules`, rule);
  }

  DeleteBillingRule(rule : BillingRuleAssignment): Observable<Object>{
    return this.http.post(environment.baseURl + `/api/clientlocation/billing/rule/delete`, rule);
  }

  UpdateProperty(loc: ClientLocation): Observable<Object>{
    return this.http.post(environment.baseURl + `/api/clientlocation/loc/updatecl`,loc)
  }

}
